import { RPCs, useRPC, RPCDocs } from '@therms/react-modules'

export function useCurrentShiftsCounts(args = {}) {
  const { call, data, isCalling } = useRPC<
    RPCDocs.Scheduling.GetCurrentShiftsCounts.v1.Args,
    RPCDocs.Scheduling.GetCurrentShiftsCounts.v1.Data
  >(RPCs.Scheduling.GetCurrentShiftsCounts.v1, args)

  let counts: RPCDocs.Scheduling.GetCurrentShiftsCounts.v1.Data
  if (data) {
    counts = data
  } else {
    counts = {
      ended: { total: 0 },
      inprogress: { total: 0 },
      notended: { total: 0 },
      notstarted: { total: 0 },
      onbreak: { total: 0 },
    }
  }

  return {
    counts,
    loading: isCalling,
    refresh: call,
  }
}
